import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5d804be6")
const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "row mb-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Energy Market Intelligence")
  ])
], -1)
const _hoisted_5 = { class: "card-body pt-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "\n                  table table-row-dashed table-row-gray-300\n                  align-middle\n                  gs-0s\n                  gy-4\n                " }
const _hoisted_8 = { class: "fw-bolder text-dark" }
const _hoisted_9 = { class: "min-w-140px ps-20" }
const _hoisted_10 = { class: "min-w-140px ps-20" }
const _hoisted_11 = { class: "min-w-100px ps-15" }
const _hoisted_12 = { class: "min-w-100px ps-15" }
const _hoisted_13 = { class: "min-w-100px ps-15" }
const _hoisted_14 = { class: "border-bottom-0" }
const _hoisted_15 = { class: "fs-3 p-3" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "fs-3 p-3" }
const _hoisted_18 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_8, [
                    _withDirectives(_createElementVNode("th", _hoisted_9, "Name", 512), [
                      [_vShow, _ctx.flag === 0]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_10, " File Name ", 512), [
                      [_vShow, _ctx.flag === 1]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_11, " Action ", 512), [
                      [_vShow, _ctx.flag === 1]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_12, " File CreatedDate ", 512), [
                      [_vShow, _ctx.flag === 0]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_13, " Last Access ", 512), [
                      [_vShow, _ctx.flag === 0]
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _withDirectives(_createElementVNode("tr", _hoisted_14, [
                    _createVNode(_component_router_link, { to: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("td", null, [
                          _createElementVNode("i", {
                            class: "bi-folder-fill text-warning fs-1 p-3",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack(_ctx.foldersList[0].FilePath)))
                          }, "..")
                        ])
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.flag === 1]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foldersList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: "border-bottom-0"
                    }, [
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(_component_router_link, { to: "" }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(
                              item.FileType === 'F'
                                ? ''
                                : 'bi-folder-fill text-warning fs-1 p-3'
                            )
                            }, null, 2),
                            _createElementVNode("span", {
                              class: "fs-3 text-left",
                              onClick: ($event: any) => (
                              _ctx.getFolders(
                                item.FilePath,
                                item.FileName,
                                item.FileType
                              )
                            )
                            }, _toDisplayString(item.FileName), 9, _hoisted_16)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _withDirectives(_createElementVNode("td", _hoisted_17, [
                        _createVNode(_component_router_link, { to: "" }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: _normalizeClass(
                              item.FileType === 'F'
                                ? 'bi-file-earmark-arrow-down-fill text-danger fs-1 p-3'
                                : 'bi-folder-fill text-warning fs-1 p-3'
                            )
                            }, null, 2),
                            _createElementVNode("span", {
                              class: "fs-3 text-left",
                              onClick: ($event: any) => (
                              _ctx.getFolders(
                                item.FilePath,
                                item.FileName,
                                item.FileType
                              )
                            )
                            }, " Download", 8, _hoisted_18)
                          ]),
                          _: 2
                        }, 1024)
                      ], 512), [
                        [_vShow, _ctx.flag === 1]
                      ]),
                      _withDirectives(_createElementVNode("td", null, _toDisplayString(item.FileCreatedDateTime), 513), [
                        [_vShow, _ctx.flag === 0]
                      ]),
                      _withDirectives(_createElementVNode("td", null, _toDisplayString(item.LastCreatedDateTime), 513), [
                        [_vShow, _ctx.flag === 0]
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}